/**
 * InputText Component - Component Definition
 * ==========================================
 */

import angular, { IModule, IComponentOptions } from 'angular';

import { InputTextController } from './controller';
import { INPUT_TEXT_TEMPLATE } from './template';
import {
  SIZES,
  BASE_CLASSES,
  ICONS,
  DEFAULTS,
  InputTextLabelPosition,
  InputTextSize,
  InputTextIconType,
  InputTextType
} from './constants';

export interface IInputTextComponentBindings {
  label?: string;
  labelPosition?: InputTextLabelPosition;
  placeholder?: string;
  icon?: InputTextIconType;
  helpMessage?: string;
  error?: boolean;
  disabled?: boolean;
  size?: InputTextSize;
  inputId?: string;
  type?: InputTextType;
  name?: string;
  autocomplete?: string;
  onChange?: (args: { value: string }) => void;
}

export const inputTextComponentDefinition: IComponentOptions = {
  template: INPUT_TEXT_TEMPLATE,
  controller: InputTextController,
  require: { ngModelCtrl: '?ngModel' },
  // Slots nombrados: <ec-label>/<ec-help> dentro del componente.
  transclude: { labelSlot: '?ecLabel', helpSlot: '?ecHelp' },
  bindings: {
    label: '@',
    labelPosition: '@',
    placeholder: '@',
    icon: '@',
    helpMessage: '@',
    error: '<',
    disabled: '<',
    size: '@',
    inputId: '@',
    type: '@',
    name: '@',
    autocomplete: '@',
    onChange: '&?'
  }
};

export const MODULE_NAME = 'ec.inputText';

const inputTextModule: IModule = angular
  .module(MODULE_NAME, ['ngSanitize'])
  .component('ecInputText', inputTextComponentDefinition);

export { InputTextController, INPUT_TEXT_TEMPLATE, SIZES, BASE_CLASSES, ICONS, DEFAULTS };
export type {
  InputTextLabelPosition,
  InputTextSize,
  InputTextIconType,
  InputTextType
} from './constants';
export default inputTextModule;
